import React from "react";
import Axios from "axios";
import Helmet from "react-helmet";
import PinInput from "./PinInput";
import Loading from "./Loading";
import ServiceError from "./ServiceError";
import ParseQueryString from "../utils/ParseQueryString";
import Analytics from "../utils/analytics";

export default class LoginCreatePin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            digitOne: "",
            digitTwo: "",
            digitThree: "",
            digitFour: "",
            loadingVisible: false,
            serviceError: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTab = this.handleTab.bind(this);
    }

    componentDidMount() {
        // Analytics: Set screen specific params
        let analytics = new Analytics(
            {
                page_sub_function: "",
                page_name: "step 2",
                page_function: "voicekey",
                device: "mobi",
                country_language: "en"
            },
            this.props.config
        );

        // Send update on "page load"
        analytics.triggerBootstrap();

        // set timeout if user sits on this screen too long (oAuth will timeout server side)
        const that = this;
        setTimeout(function() {
            that.props.onTimeout();
        }, 300000);
    }
    // TODO: Return error if 4 digits not added
    handleSubmit(event) {
        event.preventDefault();
        const userPin =
            this.state.digitOne +
            this.state.digitTwo +
            this.state.digitThree +
            this.state.digitFour;

        if (userPin.length === 4 && parseInt(userPin, 10)) {
            this.createPin(userPin);
        } else {
            this.setState({
                serviceError: "Please enter your four digit pin"
            });
        }
    }

    handleTab(event) {
        const target = event.target;
        const value = event.key;
        const name = target.id;

        let validateNum =
            name === "digitOne"
                ? value.replace(/[^1-9]/g, "")
                : value.replace(/[^0-9]/g, 0);

        this.setState({ [name]: validateNum });

        if (value.length >= target.maxLength && validateNum !== "") {
            let next = target;
            next = next.nextElementSibling;
            while (next) {
                if (
                    next.tagName.toLowerCase() === "input" ||
                    next.tagName.toLowerCase() === "button"
                ) {
                    next.focus();
                    break;
                } else {
                    // four digits filled
                    break;
                }
            }
        }
    }

    render() {
        return (
            <div className="container pin">
                <Helmet>
                    <title>
                        {this.props.config.product} - Create a Voice Key
                    </title>
                </Helmet>
                <h1>Create a Voice Key</h1>
                <p>
                    To protect your information, you must create a 4-digit
                    numerical Voice Key.
                </p>

                <p>
                    You'll be asked to say this Voice Key when you access
                    sensitive information.
                </p>

                <p>
                    <i>
                        As a best practice, do not use the same PINs you use
                        other services.
                    </i>
                </p>
                {this.state.serviceError ? (
                    <ServiceError errorMessage={this.state.serviceError} />
                ) : null}

                <form onSubmit={this.handleSubmit}>
                    <PinInput
                        name="digitOne"
                        value={this.state.digitOne}
                        controlFunc={this.handleTab}
                        autoFocus
                    />
                    <PinInput
                        name="digitTwo"
                        value={this.state.digitTwo}
                        controlFunc={this.handleTab}
                    />
                    <PinInput
                        name="digitThree"
                        value={this.state.digitThree}
                        controlFunc={this.handleTab}
                    />
                    <PinInput
                        name="digitFour"
                        value={this.state.digitFour}
                        controlFunc={this.handleTab}
                    />
                    <button
                        type="submit"
                        name="btnLogin"
                        className="ensightencustomevent"
                        data-label="Create Key"
                    >
                        <span>Create Key</span>
                    </button>
                </form>
                {this.state.loadingVisible ? <Loading /> : null}
            </div>
        );
    }

    createPin(userPin) {
        const errorMsgs = {
            "2010": "User Locked",
            "2011": "Password Expired",
            "2013": "User is not authorized to login",
            "2001": "Login Failed",
            "2007": "User Not Registered",
            "503":
                "We are sorry there has been a service error.  Please try again later.",
            "400": "Invalid login or password"
        };

        // Query Params
        const oauth_params = window.location.search;
        const baseApiUrl =
            process.env.NODE_ENV === "production"
                ? process.env.REACT_APP_PROD_API_URL
                : process.env.REACT_APP_DEV_API_URL;
        const loginApiUrl =
          baseApiUrl +
          `/v1/retailcard/identity/login/pin/create?client_id=${process.env.REACT_APP_CLIENT_ID}`;
        // user credentials
        // const userId = this.props.userId;
        const sessionId = this.props.sessionId;
        /* const oauth_clientId = decodeURIComponent(
            ParseQueryString("client_id", oauth_params)
        ); */
        const oauth_state = decodeURIComponent(
            ParseQueryString("state", oauth_params)
        );
        const oauth_redirect_uri = decodeURIComponent(
            ParseQueryString("redirect_uri", oauth_params)
        );

        // const rc_client_id = this.props.config.rc_client_id;

        /* const data = {
            sessionId: sessionId,
            pin: userPin,
            userId: userId,
            client_id: oauth_clientId,
            rcClientId: rc_client_id,
            redirect_uri: oauth_redirect_uri
        }; */
        const data = {
            'cipher.pin': userPin,
            session_info: {
                session_id: sessionId,
            },
        };

        this.setState({ loadingVisible: true });

        var that = this;

        Axios.post(loginApiUrl, data)
            .then(function(response) {
                const responseCode = response.data.status.response_code;
                that.setState({
                    loadingVisible: true
                });
                // if success, forward to redirect uri with credentials

                if (responseCode === "1001") {
                    // Analytics (Update with login complete and trigger)
                    /* that.props.analytics.pageInfo.PageKind = "login";
                    that.props.analytics.pageInfo.PageFunction = "login";
                    that.props.analytics.pageInfo.PageSubFunction = "";
                    that.props.analytics.pageInfo.pageName = "complete";*/

                    const auth_code = response.data.authorization_code;
                    //if success, redirect to redirectURI
                    window.location.href =
                        oauth_redirect_uri +
                        "?code=" +
                        auth_code +
                        "&state=" +
                        oauth_state;
                } else {
                    that.setState({
                        loadingVisible: false,
                        serviceError: errorMsgs[responseCode]
                    });
                }

                // if success route to create pin.
                //window.location.href=oauth_redirect_uri + '?code=' + auth_code + '&state=' + oauth_state;
            })
            .catch(function(error) {
                // If error, hide loading screen, clear pwd, show error
                that.setState({
                    loadingVisible: false
                });
                that.setState({ password: "" });
                that.setState({
                    serviceError: errorMsgs["400"]
                });
            });
    }
}
